import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import errorImg from "@/assets/error.jpg";
/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2021/8/12 下午7:49
 */ export class ErrorBoundary extends Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        // 你同样可以将错误日志上报给服务器
        console.error("出错了呀", error.message, errorInfo.componentStack);
    }
    render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: "center",
                    marginTop: "100px"
                },
                children: /*#__PURE__*/ _jsx("img", {
                    src: errorImg,
                    alt: "抱歉程序出错了"
                })
            });
        }
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
